import { byMedia } from '../helpers/media';
export var directionMap = new Map();
directionMap.set('ltr', 'row');
directionMap.set('rtl', 'row-reverse');
directionMap.set('ttb', 'column');
directionMap.set('btt', 'column-reverse');
export var directionKeys = ['ltr', 'rtl', 'ttb', 'btt'];
export var flexDirection = byMedia(function (value) {
  return "flex-direction: " + (directionMap.get(value) || value) + ";";
});